import React from "react";
import toastPrimitive from "react-hot-toast";
import { Notification } from "./Notification";

type T_args = {
  title?: string;
  message: React.ReactNode;
};

export const toast = {
  success: ({ title, message }: T_args) => {
    toastPrimitive.custom((t) => (
      <Notification id={t.id} title={title} message={message} type="success" />
    ));
  },
  error: ({ title, message }: T_args) => {
    toastPrimitive.custom((t) => (
      <Notification id={t.id} title={title} message={message} type="error" />
    ));
  },
};
